import * as React from 'react';
import { connect } from 'react-redux';
import { IBasePageProps, PlatypusPlotStatus } from '../../configuration/IConfiguration';
import { bindActionCreators } from 'redux';
import { IAppState } from '../../../../app';
import ContentContainer from '../../../Content/ContentContainer';
import * as AdminActionCreators from "../../../../actions/admin.actions";
import * as DataActionCreators from "../../../../actions/data.actions";
import * as DTOS from "../../../../FeralScan.dtos";
import Loader from 'react-loaders';
import { LocalForm, Control } from 'react-redux-form';
import moment = require('moment');
import PaginatedTable, { ISortOption } from '../../../Data/PaginatedTable/PaginatedTable';
import { Link } from 'react-router-dom';
import ModalMessage from '../../../Common/Modal';
import ContentTabs from '../../../Content/ContentTabs';
import UserAdminEdit from '../../../Users/UserAdminEdit';
import { PlotSortBy, sortPlots } from '../../../../helpers/graphHelper';

type PageAdminUserEditProps = {
}

type PageAdminUserEditActions = {
}

type PageAdminUserEditRouteParams = {
    userId: string;
}

type PageAdminUserEditQueryParams = {
}

type PageAdminUserEditPropsMapped = {
    user: DTOS.User;
    userLoading: boolean;
    userPlots: DTOS.Plot[];
    userPlotsLoading: boolean;
    userSaving: boolean;
    userRoles: DTOS.UserRole[];
    userRolesLoading: boolean;
}

type PageAdminUserEditActionsMapped = {
    getSingleUser: typeof AdminActionCreators.getSingleUserRequest;
    getUserPlots: typeof DataActionCreators.getUserPlotsRequest;
    saveUser: typeof AdminActionCreators.editUser;
    searchUserRoles: typeof AdminActionCreators.searchUserRolesRequest;
}

type PageAdminUserEditAllPropsInherited = PageAdminUserEditProps & PageAdminUserEditActions;
type PageAdminUserEditAllPropsMapped = PageAdminUserEditPropsMapped & PageAdminUserEditActionsMapped;

type PageAdminUserEditAllProps = IBasePageProps<PageAdminUserEditRouteParams, PageAdminUserEditQueryParams> & Partial<PageAdminUserEditAllPropsMapped> & PageAdminUserEditAllPropsInherited;

interface IPageAdminUserEditState {
}

class PageAdminUserEdit extends React.Component<PageAdminUserEditAllProps, IPageAdminUserEditState> {
    constructor(props, context) {
        super(props, context);

        this.state = {
        }
    }

    componentDidMount() {
        if (this.props.routeParams.userId) {
            const userId = Number(this.props.routeParams.userId)
            this.props.getSingleUser(userId);
            this.props.searchUserRoles(userId, undefined);
            this.props.getUserPlots(false, userId);
        }
    }

    average(sum: number, total: number) {
        if (total == 0) return 'N/A';

        return (sum / total);
    } 

    render() {

        const SortPlotsChoices: ISortOption[] = [
            { value: PlotSortBy.MYSCANSCOUNT, label: 'Scans the user made there' },
            { value: PlotSortBy.LASTSCANNED, label: 'Most recently scanned by the user' },
            { value: PlotSortBy.NAME, label: 'Alphabetically by site name' }
        ]
        
        const { user, userLoading, userPlots, userPlotsLoading, userSaving } = this.props;

        const userName = user ? user.fullName : 'Unknown User';

        return (<ContentTabs
            labelLoading={"loading user"}
            label404={"Could not find user."}
            loading={userLoading || userSaving}
            tabs={[
                {
                    dataReady: user !== undefined,
                    label: "Details",
                    labelIcon: "fa-user",
                    component: <UserAdminEdit
                        user={user}
                    />,
                    title: userName
                },
                {
                    dataReady: true,
                    label: "Data",
                    labelIcon: "fa-table",
                    component: <div className="col-12"><PaginatedTable
                        countPerPage={25}
                        data={userPlots}
                        dataColumns={[
                            {
                                className: "align-middle",
                                dataKey: "name",
                                label: "Site Name",
                            },
                            {
                                className: "align-middle",
                                classNameHeader: "",
                                dataKey: undefined,
                                label: "Last Scan",
                                render: (p: DTOS.Plot) => p.userNewestPlotEventDate ? moment(p.userNewestPlotEventDate).format(this.props.defaultDateFormat) : 'Never'
                            },
                            {
                                className: "align-middle",
                                classNameHeader: "",
                                dataKey: undefined,
                                label: "Total Scans",
                                render: (p: DTOS.Plot) => p.userPlotEventsCount
                            },
                            {
                                className: "align-middle",
                                classNameHeader: "",
                                dataKey: undefined,
                                label: "Total Sightings",
                                render: (p: DTOS.Plot) => p.userTotalSightingsCount
                            },
                            {
                                className: "align-middle",
                                classNameHeader: "",
                                dataKey: undefined,
                                label: "Average Sightings / Scam",
                                render: (p: DTOS.Plot) => this.average(p.userTotalSightingsCount, p.userPlotEventsCount)
                            },
                            {
                                className: "align-middle",
                                classNameHeader: "",
                                dataKey: undefined,
                                label: undefined,
                                render: (p: DTOS.Plot) => <i className="btn btn-primary fa fa-arrow-right"/>,
                                onClick: (p: DTOS.Plot) => this.props.history.push(`/admin/site/${p.id}`),
                            }
                        ]}
                        dataLoading={userPlotsLoading}
                        dataSortOptions={SortPlotsChoices}
                        sort={sortPlots}
                        tableClassName={"table-hover"}
                    /></div>,
                    title: userName
                }
            ]}
        />
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageAdminUserEditAllProps): PageAdminUserEditPropsMapped => {

    const user = state.admin.users && state.admin.users.length > 0 ? state.admin.users.find(u => u.id === Number(ownProps.routeParams.userId)) : undefined;

    return {
        user: user,
        userLoading: state.admin.usersLoading,
        userPlots: state.data.userPlots,
        userPlotsLoading: state.data.userPlotsLoading,
        userSaving: state.admin.userSaving,
        userRoles: state.admin.userRoles,
        userRolesLoading: state.admin.userRolesLoading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators<PageAdminUserEditActionsMapped>({
        searchUserRoles: AdminActionCreators.searchUserRolesRequest,
        getSingleUser: AdminActionCreators.getSingleUserRequest,
        getUserPlots: DataActionCreators.getUserPlotsRequest,
        saveUser: AdminActionCreators.editUser,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PageAdminUserEdit);